import React from 'react';
import { MessageCircle } from 'lucide-react';

/**
 * WhatsApp fallback CTA — shown next to / below every lead form.
 * Bypasses backend APIs entirely; opens WhatsApp chat with a pre-filled
 * message so no lead is lost even if backend/email is degraded.
 */
const WHATSAPP_NUMBER = '917757999805';

const WhatsAppFallback = ({
  prefill = 'Hi Aquarist Pools, I would like to enquire about pool services.',
  variant = 'inline',
  label = 'Or message us on WhatsApp',
}) => {
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(prefill)}`;

  if (variant === 'compact') {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-fallback-compact"
        className="inline-flex items-center gap-1.5 text-xs text-green-600 hover:text-green-700 font-semibold underline underline-offset-2"
      >
        <MessageCircle className="w-3.5 h-3.5" /> Reach us on WhatsApp
      </a>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fallback"
      className="mt-3 w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20b95a] text-white font-semibold py-3 rounded-lg transition-colors duration-200 shadow-sm"
    >
      <MessageCircle className="w-4 h-4" />
      {label}
    </a>
  );
};

export default WhatsAppFallback;
